import request from '../utils/request'

// 参展登记
export const subapply = (data) => {
    return request({
        url: '/buyer/boothapply/subapply',
        method: 'POST',
        data
    })
}
// 观众登记
export const booking = (data) => {
    return request({
        url: '/buyer/activity/booking',
        method: 'POST',
        data
    })
}
// 活动列表
export const activelist = (data) => {
    return request({
        url: '/common/activity/list',
        method: 'post',
        data
    })
}
